
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("02njT"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("02njT", function(module, exports) {

let $007246de87280af0$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $007246de87280af0$var$load("h3ABO"),
    $007246de87280af0$var$load("djHM5"),
    $007246de87280af0$var$load("eJQji"),
    $007246de87280af0$var$load("2YffH"),
    $007246de87280af0$var$load("6mHrv"),
    $007246de87280af0$var$load("awWN9"),
    $007246de87280af0$var$load("9CYct"),
    $007246de87280af0$var$load("bRKjd"),
    $007246de87280af0$var$load("ap5Gz"),
    $007246de87280af0$var$load("hZtKG"),
    $007246de87280af0$var$load("iNmaF"),
    $007246de87280af0$var$load("lVO3w"),
    $007246de87280af0$var$load("hyzoX"),
    $007246de87280af0$var$load("h9Ed7"),
    $007246de87280af0$var$load("eBRUf"),
    $007246de87280af0$var$load("kbRvk"),
    $007246de87280af0$var$load("tKhaz"),
    $007246de87280af0$var$load("5eNHu"),
    $007246de87280af0$var$load("6iBAZ"),
    $007246de87280af0$var$load("cD6Zr"),
    $007246de87280af0$var$load("fPSgL"),
    $007246de87280af0$var$load("aDOZ4"),
    $007246de87280af0$var$load("9wzNh"),
    $007246de87280af0$var$load("8YSo7"),
    $007246de87280af0$var$load("3Zfzp"),
    $007246de87280af0$var$load("Wowvf"),
    $007246de87280af0$var$load("9ldRJ"),
    $007246de87280af0$var$load("9anPW"),
    $007246de87280af0$var$load("50ame"),
    $007246de87280af0$var$load("e7ZUf"),
    $007246de87280af0$var$load("gL8bn"),
    $007246de87280af0$var$load("ebWFc"),
    $007246de87280af0$var$load("g9CVe"),
    $007246de87280af0$var$load("6iz6l"),
    $007246de87280af0$var$load("4SCW2"),
    $007246de87280af0$var$load("855o0"),
    $007246de87280af0$var$load("8MfZE"),
    $007246de87280af0$var$load("hv4mn"),
    $007246de87280af0$var$load("dek7I"),
    $007246de87280af0$var$load("dYtBN"),
    $007246de87280af0$var$load("6wr18"),
    $007246de87280af0$var$load("kjZZD"),
    $007246de87280af0$var$load("2zxmz"),
    $007246de87280af0$var$load("7269o"),
    $007246de87280af0$var$load("gizWr"),
    $007246de87280af0$var$load("4PUiY"),
    $007246de87280af0$var$load("37ldp"),
    $007246de87280af0$var$load("ffEVr"),
    $007246de87280af0$var$load("dRpV3"),
    $007246de87280af0$var$load("dTsOE"),
    $007246de87280af0$var$load("hhss7"),
    $007246de87280af0$var$load("jwTn5"),
    $007246de87280af0$var$load("aYdgM"),
    $007246de87280af0$var$load("jY21r"),
    $007246de87280af0$var$load("8fMw3"),
    $007246de87280af0$var$load("hogcU"),
    $007246de87280af0$var$load("8Vzcw"),
    $007246de87280af0$var$load("co52j"),
    $007246de87280af0$var$load("7EorR"),
    $007246de87280af0$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.0810fceb.js.map
